import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    refferalOffer: 'Get **2 free months** on any plan thanks to {0}!',
  },
  fr: {
    refferalOffer:
      'Bénéficiez quelque soit l’offre choisie, **de 2 mois offerts**, dites merci à {0} !',
  },
} as const);
